import css from './SDGeneral.module.css';

import toShort from '../../../../../services/utils/dateParser';
import QRCode from 'react-qr-code';
import DetailsGeneral from '../../../_common/elements/details/DetailsGeneral';

function SDGeneral({ student, toggleModal }) {
    let content = {};
    let functions = {};

    content.image = `url(https://upload.wikimedia.org/wikipedia/commons/8/89/Portrait_Placeholder.png`;

    content.info = [
        <p>
            Date of birth: <strong>{toShort(student.studentDoB)}</strong>
        </p>,
        <p>
            Place of birth: <strong>{student.studentPoB}</strong>
        </p>,
        <p>
            Email: <strong>{student.studentEmail}</strong>
        </p>,
        <p>
            Phone: <strong>{student.studentPhone}</strong>
        </p>,
    ];

    content.notes = (
        <p className={css.notes} style={{ fontSize: '1rem' }}>
            <strong>Notes:</strong>
            <br />
            {student.studentNotes}
        </p>
    );

    // at the moment it is only one option per student, if there are more in the future, this needs to be changed
    content.options = (
        <p className={css.notes} style={{ fontSize: '1rem' }}>
            <strong>Options:</strong>
            <br />
            {student.studentOptionTypeTitle ? (
                <>
                    {student.studentOptionTypeTitle} -{' '}
                    <span
                        style={{
                            color: student.hasStudentOption ? 'green' : 'red',
                        }}
                    >
                        {student.hasStudentOption ? 'passed' : 'rejected'}
                    </span>{' '}
                    ({toShort(student.studentOptionDate)})
                </>
            ) : (
                'No options assigned'
            )}
        </p>
    );

    content.additional = (
        <div className={css.qr}>
            {student.studentPhone && (
                <QRCode
                    value={`tel:${student.studentPhone}`}
                    level="L"
                    size={128}
                    viewBox={`0 0 128 128`}
                    bgColor="#e0ecfa"
                    fgColor="#060628"
                    title="Phone"
                />
            )}
        </div>
    );

    functions.edit = toggleModal;

    return <DetailsGeneral content={content} functions={functions} />;
}

export default SDGeneral;
